module.exports = __webpack_public_path__ + "static/media/share_pc.bf928751.png";